import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=4277796e&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=ts&"
export * from "./Review.vue?vue&type=script&lang=ts&"
import style0 from "./Review.vue?vue&type=style&index=0&id=4277796e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4277796e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomerIcon: require('/opt/build/repo/apps/shop/components/CustomerIcon.vue').default,ReviewCustomerData: require('/opt/build/repo/apps/shop/components/ReviewCustomerData.vue').default})
